import { render, staticRenderFns } from "./statAppointXiangmuJiankang.vue?vue&type=template&id=20d35f05&scoped=true"
import script from "./statAppointXiangmuJiankang.vue?vue&type=script&lang=js"
export * from "./statAppointXiangmuJiankang.vue?vue&type=script&lang=js"
import style0 from "./statAppointXiangmuJiankang.vue?vue&type=style&index=0&id=20d35f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d35f05",
  null
  
)

export default component.exports